import React from 'react'

import { SwitchDonate } from '../components/SwitchDonate'
import { useStore } from '../containers'

export function SwitchDonateStateful() {
  const { active, setActive } = useStore()

  return <SwitchDonate value={active} onChange={active => setActive(active)} />
}
